import axios from "axios";

import Constants from "@/constants/constants";

export default class Apis {
  // static BASE_URL = Constants.BASE_URL;
  // static API_PATH_PREFIX = Constants.API_PREFIX;
  // static VERSION = Constants.VERSION;
  // static FULL_URL = `${this.BASE_URL}${this.API_PATH_PREFIX}${this.VERSION}`;

  static get BASE_URL() {
    return Constants.BASE_URL;
  }

  static get API_PATH_PREFIX() {
    return Constants.API_PREFIX;
  }

  static get VERSION() {
    return Constants.VERSION;
  }

  static get FULL_URL() {
    return `${this.BASE_URL}${this.API_PATH_PREFIX}${this.VERSION}`;
  }

  static getHeaders(token: string) {
    const headers: any = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
    };
    if (token) {
      headers["X-SessionKey"] = token;
    }
    return headers;
  }

  static get(url: any, token: any, params = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.get(url, {
      headers: this.getHeaders(token),
      params: params,
    });
  }

  static postBlob(url: any, token: any, payload = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.post(url, payload, {
      responseType: "blob",
      headers: this.getHeaders(token),
    });
  }

  static post(url: any, token: any, payload = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    axios.defaults.timeout = 60000;

    return axios.post(url, payload, {
      headers: this.getHeaders(token),
    });
  }

  static postNoToken(url: any, payload = {}) {
    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.post(url, payload, {
      headers: {},
    });
  }
  static postFile(url: any, token: any, payload = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.post(url, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  static postMultiFile(url: any, token: any, payload = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.post(url, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static postMultipartForm(url: any, token: any, payload: any = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (payload[key] instanceof FileList) {
        // append multiple files
        for (let i = 0; i < payload[key].length; i++) {
          formData.append(key, payload[key][i]);
        }
      } else {
        formData.append(key, payload[key]);
      }
    });

    const headers = this.getHeaders(token);
    headers["Content-Type"] = "multipart/form-data";

    return axios.post(url, formData, {
      headers,
    });
  }

  static put(url: any, token: any, payload = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.put(url, payload, {
      headers: this.getHeaders(token),
    });
  }
  static putMultiFile(url: any, token: any, payload = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.put(url, payload, {
      headers: {
        // 'X-ApiKey': this.API_KEY,
        // 'X-SessionKey': token,
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static putMultipartForm(url: any, token: any, payload: any = {}) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    let formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (payload[key] instanceof FileList) {
        // append multiple files
        for (let i = 0; i < payload[key].length; i++) {
          formData.append(key, payload[key][i]);
        }
      } else {
        formData.append(key, payload[key]);
      }
    });

    let headers = this.getHeaders(token);
    headers["Content-Type"] = "multipart/form-data";

    return axios.put(url, formData, {
      headers,
    });
  }

  static delete(url: any, token: any) {
    if (!token) {
      token = window.localStorage.getItem("token");
    }

    // append API hostname if it's a path
    if (url.startsWith("/")) {
      url = `${this.FULL_URL}${url}`;
    }

    return axios.delete(url, {
      headers: this.getHeaders(token),
    });
  }

  // -------------------------------------------------------------------

  static async authenticate(response: any) {
    if (response.status == 401) {
      window.location.replace("/");
    }
  }
}
